/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingContact
 */
export interface BillingContact {
    /**
     * 
     * @type {string}
     * @memberof BillingContact
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContact
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContact
     */
    email?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof BillingContact
     */
    extraEmails?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof BillingContact
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContact
     */
    paymentReminderContact?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingContact
     */
    isSeparateEmailsForInvoices: boolean;
}

/**
 * Check if a given object implements the BillingContact interface.
 */
export function instanceOfBillingContact(value: object): value is BillingContact {
    if (!('isSeparateEmailsForInvoices' in value) || value['isSeparateEmailsForInvoices'] === undefined) return false;
    return true;
}

export function BillingContactFromJSON(json: any): BillingContact {
    return BillingContactFromJSONTyped(json, false);
}

export function BillingContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingContact {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'extraEmails': json['extraEmails'] == null ? undefined : json['extraEmails'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'paymentReminderContact': json['paymentReminderContact'] == null ? undefined : json['paymentReminderContact'],
        'isSeparateEmailsForInvoices': json['isSeparateEmailsForInvoices'],
    };
}

export function BillingContactToJSON(value?: BillingContact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'extraEmails': value['extraEmails'] == null ? undefined : Array.from(value['extraEmails'] as Set<any>),
        'phoneNumber': value['phoneNumber'],
        'paymentReminderContact': value['paymentReminderContact'],
        'isSeparateEmailsForInvoices': value['isSeparateEmailsForInvoices'],
    };
}

